import { removeComma } from 'utils'

/**
 * A construction budget figure the loan actually carries, or 0 when it carries none.
 *
 * `/loan/trustLedger` answers `rehabBudget` and `constructionReserve` in two different ways when
 * there is nothing to report, and only one of them is the documented sentinel. It sends **-1**
 * when the loan's product type does not expose the field at all (`visibleLoansLogic` lists the
 * pair for Fix and Flip and Ground Up Construction only), and **0** when the product does expose
 * it but nobody filled it in. Every rule that divides by the budget, or states it as a
 * percentage, has to treat those two the same way, which is what this says in one place.
 *
 * Asking only about -1 is what made a *correctly* typed loan the broken one: jasen loan 10018 is
 * Fix and Flip / Purchase with both fields left blank, so the pair arrived as 0 / 0 rather than
 * the sentinel, reached the pro-rata rule with a zero divisor and pinned Net Eligible at $0 for
 * any Gross the servicer typed, under a Percent tile reading `NaN%`. A Bridge loan carrying no
 * budget at all passed Gross straight through the whole time, which is the behaviour both shapes
 * should have had.
 *
 * Negatives collapse to 0 as well. -1 is the only one the backend sends, and a negative budget is
 * not a figure any of these rules can measure a draw against either.
 */
export const configuredAmount = (value: number | string): number => {
  const amount = removeComma(value)
  return amount > 0 ? amount : 0
}
